import React, { useState, useEffect } from 'react';
import { Quote, ChevronLeft, ChevronRight, Star } from 'lucide-react';

export default function Testimonials() {
    const testimonials = [
        {
            id: 1,
            quote: "Professional team, genuine products, and excellent customer support.",
            name: "Chinar Pharmaceuticals",
            location: "Srinagar"
        },
        {
            id: 2,
            quote: "Very satisfied with the product quality and overall service.",
            name: "Areva Lifesciences",
            location: "Panchkula, Haryana"
        },
        {
            id: 3,
            quote: "Authentic Puja Samagri and pure organic items delivered on time every month.",
            name: "Vaidik Sanatan Trust",
            location: "Varanasi, UP"
        },
        {
            id: 4,
            quote: "Great herbal and ayurvedic range. Our customers love the purity and packaging.",
            name: "AyurHerb Wellness",
            location: "Jaipur, Rajasthan"
        }
    ];

    const [currentIndex, setCurrentIndex] = useState(0);

    // Auto slide every 4.5 seconds
    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentIndex(prev => (prev >= testimonials.length - 2 ? 0 : prev + 1));
        }, 4500);
        return () => clearInterval(timer);
    }, [testimonials.length]);

    const prevSlide = () => {
        setCurrentIndex(prev => (prev === 0 ? testimonials.length - 2 : prev - 1));
    };

    const nextSlide = () => {
        setCurrentIndex(prev => (prev >= testimonials.length - 2 ? 0 : prev + 1));
    };

    return (
        <section className="bg-gradient-to-b from-white to-gray-50 py-16 px-4 overflow-hidden">
            <div className="max-w-6xl mx-auto">

                {/* Section Heading */}
                <div className="text-center mb-12">
                    <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 tracking-tight">
                        What Our Customers Say
                    </h2>
                    <p className="text-xs md:text-sm text-gray-500 mt-2">
                        Trusted by top partners, pharmaceutical companies, and holistic brands across India.
                    </p>
                </div>

                {/* Carousel / Cards Wrapper */}
                <div className="relative flex items-center">

                    {/* Left Arrow Button */}
                    <button
                        onClick={prevSlide}
                        className="absolute -left-4 md:-left-6 z-10 bg-white shadow-lg hover:bg-orange-600 hover:text-white p-2.5 rounded-full text-indigo-600 border border-gray-100 transition-all duration-300"
                    >
                        <ChevronLeft size={20} />
                    </button>

                    {/* Testimonial Cards Sliding Track */}
                    <div className="w-full overflow-hidden px-2">
                        <div
                            className="grid grid-cols-1 md:grid-cols-2 gap-6 transition-all duration-700 ease-in-out"
                        >
                            {testimonials.slice(currentIndex, currentIndex + 2).map((item) => (
                                <div
                                    key={item.id}
                                    className="bg-white p-8 rounded-3xl shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300 border border-gray-100 flex flex-col justify-between relative group"
                                >
                                    <div>
                                        <Quote size={32} className="text-orange-500/80 mb-4 fill-orange-500/10" />
                                        <p className="text-gray-700 italic text-sm md:text-base leading-relaxed">
                                            "{item.quote}"
                                        </p>
                                    </div>

                                    <div className="mt-6 pt-4 border-t border-gray-100 flex items-center justify-between">
                                        <div>
                                            <h4 className="font-bold text-gray-900 text-base">{item.name}</h4>
                                            <p className="text-xs text-gray-500 mt-0.5">{item.location}</p>
                                        </div>
                                        <div className="flex text-amber-400 gap-0.5">
                                            {[...Array(5)].map((_, i) => (
                                                <Star key={i} size={14} fill="currentColor" />
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Right Arrow Button */}
                    <button
                        onClick={nextSlide}
                        className="absolute -right-4 md:-right-6 z-10 bg-white shadow-lg hover:bg-orange-600 hover:text-white p-2.5 rounded-full text-indigo-600 border border-gray-100 transition-all duration-300"
                    >
                        <ChevronRight size={20} />
                    </button>

                </div>

                {/* Dots Indicator */}
                <div className="flex justify-center gap-2 mt-8">
                    {Array.from({ length: testimonials.length - 1 }).map((_, idx) => (
                        <button
                            key={idx}
                            onClick={() => setCurrentIndex(idx)}
                            className={`h-2.5 rounded-full transition-all duration-500 ${currentIndex === idx ? 'w-8 bg-orange-600 shadow' : 'w-2.5 bg-gray-300 hover:bg-gray-400'
                                }`}
                        />
                    ))}
                </div>

            </div>
        </section>
    );
}